import repositories from '.';

const resource = '/auth/oauth';

export default {
  checkClient: (data: any) => repositories.post(`${resource}/check-client`, data),
};
